import Vue from 'vue';
(function () {
  function validate(params) {
    const {message, required = true, min, max, trigger, call,requiredCall} = params
    const validator = (rule, value, callback) => {
      try {
        const msgVal = (typeof message === 'function') ? message() : message
        if (typeof call === 'function') {
          if ((typeof required === 'function') ? required() : required){
            if (!this._$isInteger(value) && !value) {
              callback(getNoEmptyMsg(msgVal));
            } else {
              handleCall(msgVal,call,value,callback,rule)
            }
          }else  {
            handleCall(msgVal,call,value,callback,rule)
          }
        } else if ((typeof required === 'function') ? required() : required) {
          if ((typeof requiredCall === 'function') && !requiredCall()){
            callback(getNoEmptyMsg(msgVal));
          }else if (!this._$isInteger(value) && !value) {
            callback(getNoEmptyMsg(msgVal));
          } else {
            judgeSize.call(this, msgVal, value, min, max, callback)
          }
        } else {
          judgeSize.call(this, msgVal, value, min, max, callback)
        }
      } catch (e) {
        console.log('校验代码出错了', e)
      }
    };

    return [{
      validator, trigger: trigger || 'blur', get required() {
        return (typeof required === 'function') ? required() : required
      }
    }]
  }

  /**
   * @param msgVal
   * @param call
   * @param value
   * @param rule
   */
  function handleCall(msgVal,call,value,callback,rule){
    if (call(value, rule) === false) {
      callback(new Error(msgVal));
    } else {
      callback();
    }
  }

  /**
   * @param msgVal
   * @param value
   * @param min
   * @param max
   * @param callback
   */
  function judgeSize(msgVal, value, min, max, callback) {
    const minVal = (typeof min === 'function') ? min() : min
    const maxVal = (typeof max === 'function') ? max() : max
    //如果填写 min 或者 max就证明是要进行大小写的比较
    if (minVal || maxVal || this._$isInteger(minVal) || this._$isInteger(maxVal)) {
      if (this._$isInteger(minVal) && this._$isInteger(maxVal)) {
        if (!this._$isInteger(value)) {
          if (this._$isNoEmpty(value)) {
            callback(getNoIntegerMsg(msgVal));
          } else {
            callback();
          }
        } else if (Number(value) < minVal) {
          callback(getMinMsg(msgVal, minVal));
        } else if (Number(value) > maxVal) {
          callback(getMaxMsg(msgVal, maxVal));
        } else {
          callback();
        }
      } else if (this._$isInteger(minVal)) {
        if (!this._$isInteger(value)) {
          if (this._$isNoEmpty(value)) {
            callback(getNoIntegerMsg(msgVal));
          } else {
            callback();
          }
        } else if (Number(value) < minVal) {
          callback(getMinMsg(msgVal, minVal));
        } else {
          callback();
        }
      } else if (this._$isInteger(maxVal)) {
        if (!this._$isInteger(value)) {
          if (this._$isNoEmpty(value)) {
            callback(getNoIntegerMsg(msgVal));
          } else {
            callback();
          }
        } else if (Number(value) > maxVal) {
          callback(getMaxMsg(msgVal, maxVal));
        } else {
          callback();
        }
      } else {
        callback(getNoIntegerMsg(msgVal));
      }
    } else {
      callback();
    }
  }

  function getNoEmptyMsg(msgVal) {
    return new Error(`${msgVal}不能为空`)
  }

  function getNoIntegerMsg(msgVal) {
    return new Error(`${msgVal}必须是数字`)
  }

  function getMinMsg(msgVal, min) {
    return new Error(`${msgVal}不能小于${min}`)
  }

  function getMaxMsg(msgVal, max) {
    return new Error(`${msgVal}不能大于${max}`)
  }

  /**
   * 校验不能为空
   * @param message
   * @param required 默认true
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validator = function (message, required, trigger) {
    return validate.call(this, {message, required, trigger})
  }
  /**
   * 校验不能为空
   * @param message
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validatorNoEmpty = function (message, trigger) {
    return validate.call(this, {message, trigger})
  }
  /**
   * 通过用户返回的值来校验不能为空
   * @param message
   * @param requiredCall //一个函数 返回false则代表必输校验，true必输校验通过
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validatorNoEmptyForCall = function (message,requiredCall,trigger) {
    return validate.call(this, {message,requiredCall,trigger})
  }
  /**
   * change 必输校验
   * @param message
   * @private
   */
  Vue.prototype._$validatorNoEmptyForChange = function (message) {
    return validate.call(this, {message, trigger: 'change'})
  }
  /**
   * 最小值到最大值区间校验
   * @param message
   * @param min
   * @param max
   * @param required
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validatorMinOfMax = function (message, min, max, required, trigger) {
    return validate.call(this, {message, min, max, required, trigger})
  }
  /**
   * 最小值校验
   * @param message
   * @param min
   * @param required
   * @param trigger
   * @private
   */
  Vue.prototype._$validatorMin = function (message, min, required, trigger) {
    return validate.call(this, {message, required, min, trigger})
  }
  /**
   * 最大值校验
   * @param message
   * @param max
   * @param required
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validatorMax = function (message, max, required, trigger) {
    return validate.call(this, {message, required, max, trigger})
  }
  /**
   * 使用回调形式校验
   * @param message
   * @param call 自己的回调代码 返回 true或者false 代表是否校验通过
   * @param required 默认false 也就是不进行必输校验 如果要必输 请使用组合方式
   * @param trigger 默认blur
   * @private
   */
  Vue.prototype._$validatorToCall = function (message, call, trigger) {
    return validate.call(this, {message, call,required:false, trigger})
  }
  /**
   * 使用回调形式校验
   * @param message
   * @param call 自己的回调代码 返回 true或者false 代表是否校验通过
   * @param required 默认false 也就是不进行必输校验 如果要必输 请使用组合方式
   * @param trigger 默认change
   * @private
   */
  Vue.prototype._$validatorToCallForChange = function (message, call) {
    return validate.call(this, {message, call,required:false, trigger: 'change'})
  }
  /**
   * 校验最小文字长度
   * @param message
   * @param min 最小文字长度
   * @param required
   * @param trigger
   * @returns {*}
   * @private
   */
  Vue.prototype._$validatorMinLength = function (message, min, required, trigger = 'blur') {
    const rules = validate.call(this, {message, required, trigger})
    rules.push({min, message: `${message}长度最少${min}个字符`, trigger})
    return rules
  }
  /**
   * 校验最大文字长度
   * @param message
   * @param max 最大文字长度
   * @param required
   * @param trigger
   * @returns {*}
   * @private
   */
  Vue.prototype._$validatorMaxLength = function (message, max, required, trigger = 'blur') {
    const rules = validate.call(this, {message, required, trigger})
    rules.push({max, message: `${message}长度最大${max}个字符`, trigger})
    return rules
  }
  /**
   * 校验最小到最大文字长度
   * @param message
   * @param min 最小文字长度
   * @param max 最大文字长度
   * @param required
   * @param trigger
   * @returns {*}
   * @private
   */
  Vue.prototype._$validatorMinOfMaxLength = function (message, min, max, required, trigger = 'blur') {
    const rules = validate.call(this, {message, required, trigger})
    rules.push({min, max, message: `${message}长度为${min}至${max}个字符`, trigger})
    return rules
  }
  /**
   * 组合校验
   * @param validatorArray
   * @private
   */
  Vue.prototype._$validatorConcat = function (...validatorArray) {
    return validatorArray.flat(10)
  }

})()



// WEBPACK FOOTER //
// ./src/libs/FormValidate.js